/* eslint-disable consistent-return */
/* eslint-disable import/no-cycle */
import utils from "Root/profile/utils";
import { user_pause_max_days } from "Helpers/constants";
import toastService from "Root/profile/toastService";
import { apiGetAvailableFlavors, apiGetUserCart } from "Root/api/apiProfile";
import { getAmount } from "../common/SubscriptionFlavorsSelect/SubscriptionFlavorOption";
export async function prepareFlavorsData(itemKey, selectedFlavors, allFlavorsExists) {
    const modifiedAllFlavorsObject = {};
    const modifiedAllSelectedFlavorsObject = {};
    const modifiedAllTotalSelectedObject = {};
    if (!allFlavorsExists) {
        const allFlavors = await apiGetAvailableFlavors(itemKey);
        modifiedAllFlavorsObject[itemKey] = allFlavors.flavors;
    }
    modifiedAllSelectedFlavorsObject[itemKey] = selectedFlavors.map((item) => ({
        flavor_image_url: item.flavor_image_url,
        flavor_string: item.flavor_string,
        short_name: item.short_name,
    }));
    modifiedAllTotalSelectedObject[itemKey] = selectedFlavors.length;
    return {
        modifiedAllFlavorsObject,
        modifiedAllTotalSelectedObject,
        modifiedAllSelectedFlavorsObject,
    };
}
export function prepareDefaultFlavorsObject(userCart, allFlavorsObjects, allSelectedFlavorsObjects) {
    const flavorsAmountObj = {};
    userCart.forEach((userCartItem) => {
        if (!utils.getIsBooster(userCartItem.item_type)) {
            flavorsAmountObj[userCartItem.item_type] = {};
            if (allFlavorsObjects[userCartItem.item_type]) {
                allFlavorsObjects[userCartItem.item_type].forEach((flavor) => {
                    if (allSelectedFlavorsObjects[userCartItem.item_type]) {
                        flavorsAmountObj[userCartItem.item_type][flavor.short_name] = getAmount(flavor.short_name, allSelectedFlavorsObjects[userCartItem.item_type]);
                    }
                });
            }
        }
    });
    return flavorsAmountObj;
}
export function getProductFlavorsArr(userCart, allFlavorsExists) {
    const flavorsArr = userCart.map(async (item) => {
        if (!utils.getIsBooster(item.item_type) && !utils.isAdditionalItem(item.item_type)) {
            const { modifiedAllFlavorsObject, modifiedAllSelectedFlavorsObject, modifiedAllTotalSelectedObject } = await prepareFlavorsData(item.item_type, item.flavors, allFlavorsExists);
            const totalFlavors = modifiedAllFlavorsObject[item.item_type];
            const selectedFlavors = modifiedAllSelectedFlavorsObject[item.item_type];
            const totalSelected = modifiedAllTotalSelectedObject[item.item_type];
            return {
                name: item.item_type,
                totalFlavors,
                selectedFlavors,
                totalSelected,
            };
        }
    });
    const newArr = flavorsArr.map((item) => item.then((data) => data));
    return newArr;
}
export function parseQuantityAndAttributes(userCart) {
    const additionalItemAttributeObj = {};
    const originalAttributesObj = {};
    const quantityObj = {};
    if (userCart.length !== 0) {
        userCart?.forEach((item) => {
            if (item.attributes && item.attributes.length !== 0) {
                const attributes = item.attributes.map((a) => ({
                    ...a,
                    attribute_name: a.attribute_name,
                    attribute_on: a.attribute_on,
                }));
                additionalItemAttributeObj[item.item_type] = [...attributes];
                originalAttributesObj[item.item_type] = [...attributes];
            }
            quantityObj[item.sku] = `${item.quantity}`;
        });
    }
    return { additionalItemAttributeObj, originalAttributesObj, quantityObj };
}
export function parseFlavorsArr(flavors) {
    const collectedFlavorsObj = flavors.reduce((o, v) => ({
        ...o,
        allFlavors: { ...o.allFlavors, [v?.name]: v?.totalFlavors },
        selectedFlavors: {
            ...o.selectedFlavors,
            [v?.name]: v?.selectedFlavors,
        },
        totalSelected: {
            ...o.totalSelected,
            [v?.name]: v?.totalSelected,
        },
    }), { allFlavors: {}, totalSelected: {}, selectedFlavors: {} });
    return collectedFlavorsObj;
}
export async function parseUserCart(userCart) {
    const userCartMapping = userCart.map((item) => ({ ...item }));
    const { additionalItemAttributeObj, originalAttributesObj, quantityObj } = parseQuantityAndAttributes(userCartMapping);
    const flavors = await Promise.all(getProductFlavorsArr(userCart));
    const filteredFlavors = flavors.filter((item) => !!item);
    const collectedFlavorsObj = parseFlavorsArr(filteredFlavors);
    const defaultFlavorsAmount = prepareDefaultFlavorsObject(userCartMapping, collectedFlavorsObj.allFlavors, collectedFlavorsObj.selectedFlavors);
    const originalDefaultFlavorsAmount = {
        ...prepareDefaultFlavorsObject(userCartMapping, collectedFlavorsObj.allFlavors, collectedFlavorsObj.selectedFlavors),
    };
    return {
        additionalItemAttributeObj,
        originalAttributesObj,
        quantityObj,
        userCartMapping,
        collectedFlavorsObj,
        defaultFlavorsAmount,
        originalDefaultFlavorsAmount,
    };
}
export async function fetchAndParseUserCart() {
    const userCart = await apiGetUserCart();
    return parseUserCart(userCart);
}
export function prepareUpdateItemBody(userCart) {
    const protein = userCart.find((item) => item.item_type === "protein");
    const initialBody = {
        additional_items_to_update: [],
        flavor_sticks_to_update: {
            flavors: "",
        },
        flavors_to_update: [],
        next_order_only: false,
        quantity_to_update: [],
    };
    if (protein) {
        const flavorSticks = protein.bags_info[0].selected_flavors.reduce((prev, curr) => ({
            ...prev,
            [curr.short_name]: curr.count,
        }), {});
        initialBody.flavor_sticks_to_update = { flavors: JSON.stringify(flavorSticks) };
    }
    const quantityToUpdate = [];
    const flavorsToUpdateItem = [];
    const additionalItemsToUpdate = [];
    userCart.forEach((item) => {
        item.bags_info.forEach((bag, i) => {
            flavorsToUpdateItem.push({
                product: item.item_type,
                item: i === 0 ? item.sku : item.item_type + i,
                flavors: JSON.stringify(bag.selected_flavors.reduce((prev, curr) => ({
                    ...prev,
                    [curr.short_name]: curr.count,
                }), {})),
            });
            additionalItemsToUpdate.push({
                product: item.item_type,
                item: i === 0 ? item.sku : item.item_type + i,
                attributes: {
                    [item.item_type]: bag.attributes,
                },
            });
            quantityToUpdate.push({
                item: i === 0 ? item.sku : item.item_type + i,
                quantity: ["preworkout", "hydration", "greens"].includes(item.item_type) ? 1 : Number(item.quantity),
            });
        });
    });
    initialBody.flavors_to_update = flavorsToUpdateItem;
    initialBody.additional_items_to_update = additionalItemsToUpdate;
    initialBody.quantity_to_update = quantityToUpdate;
    return initialBody;
}
export async function prepareUpdatedFlavorsData(cart, allFlavors) {
    const flavors = await Promise.all(getProductFlavorsArr(cart, true));
    const filteredFlavors = flavors.filter((item) => !!item);
    const collectedFlavorsObj = parseFlavorsArr(filteredFlavors);
    const originalDefaultFlavorsAmount = {
        ...prepareDefaultFlavorsObject(cart, allFlavors, collectedFlavorsObj.selectedFlavors),
    };
    const defaultFlavorsAmount = prepareDefaultFlavorsObject(cart, allFlavors, collectedFlavorsObj.selectedFlavors);
    return {
        collectedFlavorsObj,
        defaultFlavorsAmount,
        originalDefaultFlavorsAmount,
    };
}
export function resetFlavorsAmount(flavorObj) {
    const resetedFlavors = {};
    Object.keys(flavorObj).forEach((key) => {
        resetedFlavors[key] = 0;
    });
    return resetedFlavors;
}
export function updateAttributeHelper(attributes, value, propertyName) {
    let selectedAttribute = attributes.find((item) => item.attribute_name === propertyName);
    const selectedAttributeIndex = attributes.findIndex((item) => item.attribute_name === propertyName);
    if (selectedAttribute) {
        selectedAttribute = {
            ...selectedAttribute,
            attribute_on: value,
        };
        const copyAttrubuteArr = [...attributes];
        copyAttrubuteArr[selectedAttributeIndex] = selectedAttribute;
        return copyAttrubuteArr;
    }
    return null;
}
export function getUpdatedAttributeHelper(additionalItemAttribute, value, propertyName, itemName) {
    let selectedAttribute = additionalItemAttribute[itemName].find((item) => item.attribute_name === propertyName);
    const selectedAttributeIndex = additionalItemAttribute[itemName].findIndex((item) => item.attribute_name === propertyName);
    if (selectedAttribute) {
        selectedAttribute = {
            ...selectedAttribute,
            attribute_on: value,
        };
        const copyAttrubuteArr = [...additionalItemAttribute[itemName]];
        copyAttrubuteArr[selectedAttributeIndex] = selectedAttribute;
        const copyAdditionalAttributeObj = {
            ...additionalItemAttribute,
            [itemName]: copyAttrubuteArr,
        };
        return copyAdditionalAttributeObj;
    }
    return null;
}
export function getSelectedProduct(product, cart) {
    if (product) {
        return cart.find((item) => item.item_type === product);
    }
    return null;
}
export const prepareDateToPost = (date) => `${date.getFullYear()},${date.getMonth()},${date.getDate()}`;
export const getSnoozeOrderDate = (week, dateObj) => {
    const d = new Date(dateObj.year, dateObj.month, dateObj.day);
    d.setDate(d.getDate() + week * 7);
    return d;
};
export const cadenceValues = [
    { label: "Every 3 weeks", value: 3 },
    { label: "Every 4 weeks", value: 4 },
    { label: "Every 6 weeks", value: 6 },
    { label: "Every 8 weeks", value: 8 },
    { label: "Every 12 weeks", value: 12 },
];
export const planTypeValues = [
    {
        label: "Standard Plan",
        value: "standard",
        subLabel: "1 order shipped every 4 weeks",
    },
    {
        label: "Advantage Plan",
        value: "advantage",
        subLabel: "3 orders shipped together, every 3 months",
    },
];
export const skipOrderValues = [
    {
        label: "I’m traveling",
        value: "traveling",
    },
    {
        label: "I’m injured/sick",
        value: "injured",
    },
    {
        label: "I haven’t been exercising as much as I’d like",
        value: "exercising",
    },
    {
        label: "It is too expensive",
        value: "expensive",
    },
    {
        label: "I have too much product right now",
        value: "tooMuch",
    },
    {
        label: "Other",
        value: "other",
    },
];
export const getPricingTotal = (pricing) => (pricing && pricing.length && pricing[pricing.length - 1]?.line_item_price) || "";
export const addDays = (dateObj, days) => {
    const date = new Date(dateObj);
    date.setDate(date.getDate() + days);
    return date;
};
export const getDateForCalendar = (nextBillingObj) => {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 1);
    const currentOrderDate = new Date(nextBillingObj.year, nextBillingObj.month, nextBillingObj.day);
    const maxDate = addDays(currentOrderDate, user_pause_max_days);
    return { minDate, maxDate };
};
export function prepareDataToUpdateNextOrder(quantity, flavorsObj, attributes) {
    const productsToUpdate = [];
    const productsToRemove = [];
    Object.keys(flavorsObj).forEach((key) => {
        Object.keys(flavorsObj[key]).forEach((item) => {
            if (flavorsObj[key][item] !== 0) {
                productsToUpdate.push({ sku: item, quantity: flavorsObj[key][item] });
            }
            else {
                productsToRemove.push({ sku: item });
            }
        });
    });
    Object.keys(quantity).forEach((key) => {
        if (key.indexOf("PW") !== 0) {
            const pwAttribute = attributes.preworkout;
            if (pwAttribute) {
                const flavorsKey = Object.keys(flavorsObj.preworkout)[0];
                productsToUpdate.push({
                    sku: key,
                    quantity: Number(quantity[key]),
                    preworkout_caffeinated: pwAttribute.find((attr) => attr.attribute_name === "preworkout_caffeinated")
                        ?.attribute_on,
                    wantsCreatine: pwAttribute.find((attr) => attr.attribute_name === "wantsCreatine")?.attribute_on,
                    flavor: flavorsKey,
                });
            }
        }
        if (key.indexOf("lemonlime") !== -1 || key.indexOf("lemonade") !== -1) {
            const hydrationAttribute = attributes.hydration;
            if (hydrationAttribute) {
                const flavorsKey = Object.keys(flavorsObj.hydration)[0];
                productsToUpdate.push({
                    sku: key,
                    quantity: Number(quantity[key]),
                    hydration_caffeinated: hydrationAttribute.find((attr) => attr.attribute_name === "hydration_caffeinated")
                        ?.attribute_on,
                    sweat_level: null,
                    flavor: flavorsKey,
                });
            }
        }
        else {
            productsToUpdate.push({ sku: key, quantity: Number(quantity[key]) });
        }
    });
    const filteredProductsToUpdate = productsToUpdate.filter((item) => !!item.sku);
    return { productsToUpdate: filteredProductsToUpdate, productsToRemove };
}
export const getChanges = (originalSelectedAnswers, selectedAnswers) => {
    const changes = {};
    Object.keys(originalSelectedAnswers).forEach((key) => {
        if (JSON.stringify(originalSelectedAnswers[key]) !== JSON.stringify(selectedAnswers[key])) {
            changes[key] = selectedAnswers[key];
        }
    });
    return changes;
};
export const formatDate = (dataObj) => `${dataObj.month}/${dataObj.day}/${dataObj.year}`;
export const capitalizeFirstLetter = (string) => string.replace(/\w/, (firstLetter) => firstLetter.toUpperCase());
export const validateFlavorsQuantity = (userCart, originalUserCart) => {
    const getItem = (cart, itemType) => cart.find((item) => item.item_type === itemType);
    const protein = getItem(userCart, "protein");
    const hydration = getItem(userCart, "hydration");
    const pw = getItem(userCart, "preworkout");
    const originalprotein = getItem(originalUserCart, "protein");
    const originalHydration = getItem(originalUserCart, "hydration");
    const originalPw = getItem(originalUserCart, "preworkout");
    const getTotal = (item) => item?.bags_info
        .map((bag) => bag.selected_flavors.reduce((prev, curr) => prev + curr.count, 0))
        .reduce((prev, curr) => prev + curr, 0);
    const totalSelected = {
        protein: (protein?.bags_info.length &&
            protein.bags_info[0].selected_flavors.reduce((prev, curr) => prev + curr.count, 0)) ||
            undefined,
        hydration: hydration && getTotal(hydration),
        pw: pw && getTotal(pw),
    };
    const originalTotalSelected = {
        protein: (originalprotein?.bags_info.length &&
            originalprotein.bags_info[0].selected_flavors.reduce((prev, curr) => prev + curr.count, 0)) ||
            0,
        hydration: (originalHydration && getTotal(originalHydration)) || 0,
        pw: (originalPw && getTotal(originalPw)) || 0,
    };
    if (protein?.quantity !== undefined &&
        Number(protein?.quantity) === 2 &&
        totalSelected.protein &&
        ((totalSelected.protein > 0 && totalSelected.protein !== 4) || totalSelected.protein % 2 !== 0)
    // isNoFlagMissed(totalSelected.protein, noFlavorsFlag, originalTotalSelected.protein))
    ) {
        toastService.errorMessage("Please select 4 Flavors or choose “No Flavors”");
        return false;
    }
    if (totalSelected.protein !== undefined &&
        Number(protein?.quantity) === 1 &&
        originalTotalSelected.protein !== 0 &&
        Number(originalTotalSelected.protein) !== Number(totalSelected.protein) &&
        ((totalSelected.protein > 0 && totalSelected.protein > 2) || totalSelected.protein % 2 !== 0)
    // isNoFlagMissed(totalSelected.protein, noFlavorsFlag, originalTotalSelected.protein))
    ) {
        toastService.errorMessage("Please select 2 Flavors or choose “No Flavors”");
        return false;
    }
    if (totalSelected.hydration && totalSelected.hydration !== hydration?.quantity) {
        toastService.errorMessage("Please select a Hydration flavor");
        return false;
    }
    // if (totalSelected.hydration !== undefined && Number(hydration?.quantity) !== 0 && totalSelected.hydration !== 1) {
    //   toastService.errorMessage("Please select a Hydration flavor");
    //   return false;
    // }
    if (totalSelected.pw && totalSelected.pw !== pw?.quantity) {
        toastService.errorMessage("Please select a Pre-Workout flavor");
        return false;
    }
    // if (totalSelected.pw !== undefined && Number(pw?.quantity) !== 0 && totalSelected.pw !== 1) {
    //   toastService.errorMessage("Please select a Pre-Workout flavor");
    //   return false;
    // }
    return true;
};
export const getFlavorsQuantityChange = (originalUserCart, newUserCart) => {
    const getProduct = (cart, productName) => {
        const selectedProduct = cart &&
            cart
                .map((item) => Object.entries(item))
                .map((entry) => entry.filter((keyVal) => keyVal[0] === "item_type" || keyVal[0] === "quantity" || keyVal[0] === "bags_info"))
                .find((prod) => prod[1][1] === productName);
        return Object.fromEntries(new Map(selectedProduct));
    };
    const origPR = originalUserCart.find((item) => item.item_type === "protein") && getProduct(originalUserCart, "protein");
    const newPR = newUserCart.find((item) => item.item_type === "protein") && getProduct(newUserCart, "protein");
    const origHY = originalUserCart.find((item) => item.item_type === "hydration") && getProduct(originalUserCart, "hydration");
    const newHY = newUserCart.find((item) => item.item_type === "hydration") && getProduct(newUserCart, "hydration");
    const origPW = originalUserCart.find((item) => item.item_type === "preworkout") && getProduct(originalUserCart, "preworkout");
    const newPW = newUserCart.find((item) => item.item_type === "preworkout") && getProduct(newUserCart, "preworkout");
    const origCR = originalUserCart.find((item) => item.item_type === "creatine") && getProduct(originalUserCart, "creatine");
    const newCR = newUserCart.find((item) => item.item_type === "creatine") && getProduct(newUserCart, "creatine");
    const origCO = originalUserCart.find((item) => item.item_type === "collagen") && getProduct(originalUserCart, "collagen");
    const newCO = newUserCart.find((item) => item.item_type === "collagen") && getProduct(newUserCart, "collagen");
    const origFI = originalUserCart.find((item) => item.item_type === "fiber") && getProduct(originalUserCart, "fiber");
    const newFI = newUserCart.find((item) => item.item_type === "fiber") && getProduct(newUserCart, "fiber");
    const isQuantityEqual = (originalProduct, newProduct) => {
        let equal;
        if (originalProduct && originalProduct.quantity && newProduct && newProduct.quantity) {
            equal = JSON.stringify(originalProduct.quantity) !== JSON.stringify(newProduct.quantity);
        }
        return equal;
    };
    const isFlavourEqual = (originalProduct, newProduct) => {
        let equal;
        if (originalProduct && originalProduct.bags_info && newProduct && newProduct.bags_info) {
            const origFlavours = [];
            const newFlavours = [];
            originalProduct.bags_info.forEach((item) => item.selected_flavors.length > 0 && origFlavours.push(item.selected_flavors));
            newProduct.bags_info.map((item) => item.selected_flavors.length > 0 && newFlavours.push(item.selected_flavors));
            equal = JSON.stringify(origFlavours) !== JSON.stringify(newFlavours);
        }
        return equal;
    };
    const proteinChange = {
        item: origPR?.item_type,
        quantity: isQuantityEqual(origPR, newPR),
        flavor: isFlavourEqual(origPR, newPR),
    };
    const hydrationChange = {
        item: origHY?.item_type,
        quantity: isQuantityEqual(origHY, newHY),
        flavor: isFlavourEqual(origHY, newHY),
    };
    const preworkoutChange = {
        item: origPW?.item_type,
        quantity: isQuantityEqual(origPW, newPW),
        flavor: isFlavourEqual(origPW, newPW),
    };
    const creatineChange = {
        item: origCR?.item_type,
        quantity: isQuantityEqual(origCR, newCR),
        flavor: isFlavourEqual(origCR, newCR),
    };
    const collagenChange = {
        item: origCO?.item_type,
        quantity: isQuantityEqual(origCO, newCO),
        flavor: isFlavourEqual(origCO, newCO),
    };
    const fiberChange = {
        item: origFI?.item_type,
        quantity: isQuantityEqual(origFI, newFI),
        flavor: isFlavourEqual(origFI, newFI),
    };
    const allProducts = [proteinChange, hydrationChange, preworkoutChange, creatineChange, collagenChange, fiberChange];
    const actualProducts = allProducts.filter((item) => item.item);
    const quantityChangeArr = [];
    actualProducts.filter((item) => item.quantity === true).forEach((prod) => quantityChangeArr.push(prod.item));
    const flavorChangeArr = [];
    actualProducts.filter((item) => item.flavor === true).forEach((prod) => flavorChangeArr.push(prod.item));
    return [quantityChangeArr.join(", "), flavorChangeArr.join(", ")];
};
export const validateProductAttributes = (attributes, item_type) => {
    if (attributes) {
        if (item_type === "preworkout") {
            const isEveryAttributeIsFalse = attributes.every((item) => item.attribute_on === false);
            if (isEveryAttributeIsFalse) {
                toastService.errorMessage("Pre-Workout formulas must include either creatine or caffeine.");
                return false;
            }
        }
    }
    return true;
};
export const validateAttributes = (attributes) => {
    if (attributes && attributes.preworkout) {
        const isEveryAttributeIsFalse = attributes.preworkout.every((item) => item.attribute_on === false);
        if (isEveryAttributeIsFalse) {
            toastService.errorMessage("Pre-Workout formulas must include either creatine or caffeine.");
            return false;
        }
        return true;
    }
    return true;
};
export const convertFlavorsToArr = (flavorsObj) => {
    const productsToUpdate = [];
    Object.keys(flavorsObj).forEach((item) => {
        if (flavorsObj[item] !== 0) {
            productsToUpdate.push({ sku: item });
        }
    });
    return productsToUpdate;
};
export const hasAttributeError = (e) => {
    const { message } = e;
    const errorObject = JSON.parse(message);
    return errorObject && errorObject.attribute_error;
};
export const onOrderItemAttributeChange = (value, propertyName, itemName, additionalItemAttribute, setAdditionalItemAttribute) => {
    const copyAdditionalAttributeObj = getUpdatedAttributeHelper(additionalItemAttribute, value, propertyName, itemName);
    const isValid = validateAttributes(copyAdditionalAttributeObj);
    if (isValid && copyAdditionalAttributeObj) {
        setAdditionalItemAttribute(copyAdditionalAttributeObj);
    }
};
export const copyObject = (obj) => JSON.parse(JSON.stringify(obj));
export const validateAddItemBody = (body) => {
    if ((body.item === "hydration" || body.item === "preworkout") && body.flavors.length !== 1) {
        toastService.errorMessage(`Please select your ${body.item} flavor(s).`);
        return false;
    }
    if (body.item === "protein") {
        const flavorItemsArr = body.flavors;
        if (flavorItemsArr && flavorItemsArr.length) {
            const requiredFlavorsNumber = body.quantity * 2;
            if (requiredFlavorsNumber !== flavorItemsArr.length) {
                toastService.errorMessage(`Please select ${requiredFlavorsNumber} Flavors or choose “No Flavors”`);
                return false;
            }
        }
        return true;
    }
    return true;
};
export const validateAddToGetITNowItemBodyWithBags = (bags_info, quantity, item_type, title) => {
    if (item_type === "hydration" || item_type === "preworkout") {
        const isFlavorsSelected = bags_info.map((item) => item.selected_flavors.filter((flav) => !!flav.count)).flat();
        if (!isFlavorsSelected.length) {
            toastService.errorMessage(`Please choose a ${title} flavor.`);
            return false;
        }
        return true;
    }
    if (item_type === "protein") {
        const flavorsCount = bags_info && bags_info[0].selected_flavors.reduce((prev, curr) => prev + curr.count, 0);
        if (flavorsCount) {
            const requiredFlavorsNumber = quantity * 2;
            if (requiredFlavorsNumber !== flavorsCount) {
                toastService.errorMessage(`Please select ${requiredFlavorsNumber} Flavors or choose “No Flavors”`);
                return false;
            }
        }
        return true;
    }
    return true;
};
export const MDYDate = (dateStr) => {
    const initDateArr = dateStr.includes("/") ? dateStr.split("/") : dateStr.split("-");
    if (initDateArr.length !== 0) {
        return dateStr.includes("/")
            ? [initDateArr[1], initDateArr[0], initDateArr[2]].join("/")
            : [initDateArr[1], initDateArr[2], initDateArr[0]].join("-");
    }
    return "";
};
export const getPartOfSMSString = () => {
    const { userAgent } = window.navigator;
    if (userAgent.includes("Linux" || "Android" || null || "BlackBerry" || "Windows" || "Win")) {
        return "?";
    }
    if (userAgent.includes("iPhone" || "iPod" || "iPad" || "Mac" || "Pike")) {
        return "&";
    }
    return "";
};
